<template>
  <BaseButton :variant="variant" @click="$emit('click')">
    <BaseIcon v-if="isShowIcon" icon-name="preview" :width="iconWidth" :height="iconHeight">
      <IconPreview></IconPreview>
    </BaseIcon>
    <slot></slot>
  </BaseButton>
</template>

<script>
import buttonMixin from '@/mixins/button';
import BaseIcon from '@/components/BaseIcon.vue';
import IconPreview from '@/components/icon/IconPreview.vue';

export default {
  mixins: [buttonMixin],
  components: {
    BaseIcon,
    IconPreview,
  },
  props: {
    variant: { type: String, default: 'primary' },
  },
};
</script>

<style lang="scss" scoped></style>
